import { useCallback } from 'react'
import ApiService from '../../../../services/ApiService'

const InteractorMasterMenuTeamList = () => {
  const listMenu = useCallback((body, callback) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/master-menu/team-list', payload, response => {
      if (response.status_code === 200) {
        callback(response.data)
      }
    })
  }, [])

  return { listMenu }
}

export default InteractorMasterMenuTeamList
